import { render, staticRenderFns } from "./draftList.vue?vue&type=template&id=fd8d3b08"
import script from "./draftList.vue?vue&type=script&lang=js"
export * from "./draftList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports